// extracted by mini-css-extract-plugin
module.exports = {"color-dark":"DallasImageTruckSmarterLogo_color-dark__kYnyi","color-brand":"DallasImageTruckSmarterLogo_color-brand__Y8Esr"};